<template>
  <div
    class="scheduleDetail_baseInfor"
    :class="
      currMatchDetailInfor && currMatchDetailInfor.type
        ? currMatchDetailInfor.type
        : ''
    "
  >
    <template v-if="currMatchDetailInfor">
      <span class="infor_left">
        <span
          class="matchName"
          v-text="currMatchDetailInfor.scheduleName"
        ></span>
        <span
          class="matchStatus"
          v-text="currMatchDetailInfor.matchStatus"
        ></span>
      </span>
      <span class="infor_center">
        <!-- <span class="group_item A">
                <span class="vsLeftArea">
                  <span class="participantItem">
                    <span class="participantLogo">
                      <img :src="''" />
                    </span>
                    <span class="participantName" v-text="'印度尼西亚'"></span>
                  </span>
                </span>
                <span class="vsArea">
                  <span class="leftScore" v-text="99"></span>
                  <span class="vs" v-text="'vs'"></span>
                  <span class="rightScore" v-text="99"></span>
                </span>
                <span class="vsRightArea">
                  <span class="participantItem">
                    <span class="participantLogo">
                      <img :src="''" />
                    </span>
                    <span class="participantName" v-text="'印度尼西亚'"></span>
                  </span>
                </span>
              </span> -->
        <template v-if="currMatchDetailInfor.competitorType !== 'T'">
          <span class="group_item" :class="currMatchDetailInfor.competitorType">
            <span class="vsLeftArea">
              <span
                class="participantItem"
                v-for="item in currMatchDetailInfor.competitor1Names"
                :key="item.playerName"
              >
                <span
                  class="participantLogo"
                  :class="item.playerLogo ? 'isLogo' : ''"
                >
                  <img v-if="item.playerLogo" :src="item.playerLogo" />
                </span>
                <span class="participantName" v-text="item.playerName"></span>
              </span>
              <!-- <span class="participantItem">
                      <span class="participantLogo">
                        <img :src="''" />
                      </span>
                      <span class="participantName" v-text="'印度尼西亚'"></span>
                    </span> -->
            </span>
            <span class="vsArea">
              <span
                class="leftScore"
                v-text="currMatchDetailInfor.homeScore"
              ></span>
              <span class="vs" v-text="'vs'"></span>
              <span
                class="rightScore"
                v-text="currMatchDetailInfor.awayScore"
              ></span>
              <span
                class="stringScore home"
                v-text="currMatchDetailInfor.irm1Result"
              ></span>
              <span
                class="stringScore away"
                v-if="currMatchDetailInfor.irm2Result"
                v-text="currMatchDetailInfor.irm2Result"
              ></span>
              <span
                class="absArea_currServe"
                v-show="
                  showCurrServe_SportIds.includes(
                    currMatchDetailInfor.sportsId
                  ) && currMatchDetailInfor.matchStatus === '比赛中'
                "
              >
                <span class="currServeLeft">
                  <span
                    class="currServe_icon"
                    :class="
                      currMatchDetailInfor.currentServer &&
                      ['0', '2'].includes(currMatchDetailInfor.currentServer)
                        ? 'show'
                        : ''
                    "
                  ></span>
                  <span class="currServe_scoreArea">
                    <span
                      class="currServe_score"
                      v-text="currMatchDetailInfor.currentGameResult1"
                    ></span>
                  </span>
                </span>
                <span class="currServeRight">
                  <span class="currServe_scoreArea">
                    <span
                      class="currServe_score"
                      v-text="currMatchDetailInfor.currentGameResult2"
                    ></span>
                  </span>
                  <span
                    class="currServe_icon"
                    :class="
                      currMatchDetailInfor.currentServer &&
                      ['1', '3'].includes(currMatchDetailInfor.currentServer)
                        ? 'show'
                        : ''
                    "
                  ></span>
                </span>
              </span>
            </span>
            <span class="vsRightArea">
              <span
                class="participantItem"
                v-for="item in currMatchDetailInfor.competitor2Names"
                :key="item.playerName"
              >
                <span
                  class="participantLogo"
                  :class="item.playerLogo ? 'isLogo' : ''"
                >
                  <img v-if="item.playerLogo" :src="item.playerLogo" />
                </span>
                <span class="participantName" v-text="item.playerName"></span>
              </span>
              <!-- <span class="participantItem">
                      <span class="participantLogo">
                        <img :src="''" />
                      </span>
                      <span class="participantName" v-text="'印度尼西亚'"></span>
                    </span> -->
            </span>
          </span>
        </template>
        <template v-else>
          <span class="group_item" :class="currMatchDetailInfor.competitorType">
            <span class="vsLeftArea">
              <span class="participantItem">
                <span class="participantLogo">
                  <img :src="currMatchDetailInfor.homeLogo" />
                </span>
                <span
                  class="participantName"
                  v-text="currMatchDetailInfor.homeName"
                ></span>
              </span>
            </span>
            <span class="vsArea">
              <span
                class="leftScore"
                v-text="currMatchDetailInfor.homeScore"
              ></span>
              <span class="vs" v-text="'vs'"></span>
              <span
                class="rightScore"
                v-text="currMatchDetailInfor.awayScore"
              ></span>
              <span
                class="stringScore home"
                v-if="currMatchDetailInfor.irm1Result"
                v-text="currMatchDetailInfor.irm1Result"
              ></span>
              <span
                class="stringScore away"
                v-if="currMatchDetailInfor.irm2Result"
                v-text="currMatchDetailInfor.irm2Result"
              ></span>
            </span>
            <span class="vsRightArea">
              <span class="participantItem">
                <span class="participantLogo">
                  <img :src="currMatchDetailInfor.awayLogo" />
                </span>
                <span
                  class="participantName"
                  v-text="currMatchDetailInfor.awayName"
                ></span>
              </span>
            </span>
          </span>
        </template>
      </span>
      <span class="infor_right">
        <span class="rightTopArea">
          <span
            class="resultType"
            :class="
              currMatchDetailInfor.currResultType &&
              currMatchDetailInfor.currResultType.name
                ? `isShow ${currMatchDetailInfor.currResultType.className}`
                : ''
            "
            v-text="
              currMatchDetailInfor.currResultType
                ? currMatchDetailInfor.currResultType.name
                : ''
            "
          ></span>
          <span
            v-if="themeItem"
            class="publishBtn"
            @click="clickPublicTheme(themeItem)"
          >
            <svg
              t="1692698307306"
              class="publishBtn_icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="9670"
              width="100%"
              height="100%"
            >
              <path
                d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
                p-id="9671"
              ></path>
            </svg>
          </span>
        </span>
        <span class="venueName" v-text="currMatchDetailInfor.venueName"></span>
      </span>
    </template>
  </div>
</template>
<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'compreSportsMeet_scheduleDetail_baseInfor',
  mixins: [cup_base_data_mixin],
  props: {
    CSMeetScheduleInfo: {
      type: Object,
      default: () => ({}),
    },
    themeItem: {
      type: Object,
      default: () => {
        return null
      },
    },
  },
  data() {
    return {
      showCurrServe_SportIds: ['TEN'], //目前只有网球类赛果需要这个发球权的展示
    }
  },
  computed: {
    currMatchDetailInfor() {
      console.debug('this.CSMeetScheduleInfo:', this.CSMeetScheduleInfo)
      return this.CSMeetScheduleInfo
      // return {
      //   disciplineCode: null,
      //   disciplineName: null,
      //   disciplineLogo: null,
      //   startDatetimeUtc: '2022-05-08T20:00:00',
      //   formatDate: '05月08日',
      //   formatTime: '20:00',
      //   scheduleCode: '100376',
      //   scheduleName: '汤姆斯杯小组赛A组',
      //   scheduleStatus: '4',
      //   medalFlag: null,
      //   eventCode: 'MT',
      //   eventName: '汤姆斯杯',
      //   phaseName: '小组赛A组',
      //   venueCode: null,
      //   venueName: 'Impact Arena',
      //   competitorType: 'T',
      //   competitor1Code: '10017',
      //   competitor2Code: '10001',
      //   competitor1Name: '韩国',
      //   competitor2Name: '泰国',
      //   competitor1Names: null,
      //   competitor2Names: null,
      //   organisation1Code: '1018',
      //   organisation1Name: '韩国',
      //   organisation1Logo:
      //     'https://hyper-sports-res.mixtmt.com/badminton/season/5032022/team/1018.png',
      //   organisation2Code: '1032',
      //   organisation2Name: '泰国',
      //   organisation2Logo:
      //     'https://hyper-sports-res.mixtmt.com/badminton/season/5032022/team/1032.png',
      //   competitor1Result: '3',
      //   competitor2Result: '2',
      //   irm1Result: null,
      //   irm2Result: null,
      //   matchResult: null,
      //   unitType: null,
      //   annotation: null,
      //   medals: null,
      //   cn: false,
      //   confrontation: true,
      //   currentGameResult1: '0',
      //   currentGameResult2: '0',
      //   currentServer: '1', //0和2是主    1和3是客
      // }
    },
  },
  methods: {
    clickPublicTheme(themeItem) {
      if (themeItem) {
        this.$emit('clickPublicThemeEvent', themeItem)
      } else {
        console.debug('themeItem 不存在')
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.scheduleDetail_baseInfor {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 1.38vw;
  width: 100%;
  height: 8.472vw;
  padding: 0 1.38vw;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: left top;
  background-image: var(--mixtmt_matchDetail_inforBg);
  color: var(--mixtmt_whiteColor);
  &.uncombat {
    justify-content: space-between;
    .infor_left,
    .infor_right {
      width: 50%;
    }
    .infor_center {
      display: none;
    }
  }
  .infor_left,
  .infor_right {
    width: calc((100% - 44.4vw) / 2);
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
  }
  .infor_left {
    justify-content: center;
    align-items: flex-start;
    .matchName {
      width: 100%;
      font-size: 1.38vw;
      line-height: 2.083vw;
      height: 4.166vw;
      white-space: normal;
      text-align: left;
    }
    /* .matchStatus {
    } */
  }
  .infor_right {
    position: relative;
    justify-content: space-between;
    align-items: flex-end;
    padding: 1.041vw 0 1.38vw 0;
    height: 100%;
    .rightTopArea {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-end;
      align-items: center;
      width: auto;
    }
    .resultType {
      width: auto;
      padding: 0.208vw 1.041vw;
      font-size: 0.972vw;
      border-radius: 1.041vw;
      &.isShow:not(.matchDate) {
        border: 1px solid var(--mixtmt_whiteColor);
      }
      &.matchDate {
        font-size: 1.25vw;
        padding: 0.208vw 0.694vw;
      }
    }
    .venueName {
      position: relative;
      font-size: 1.11vw;
      padding-left: 1.38vw;
      &::before {
        position: absolute;
        left: 0;
        top: 50%;
        z-index: 2;
        content: '\20';
        width: 1.11vw;
        height: 1.11vw;
        background-image: var(--mixtmt_scheduleMatchList_sportHall_icon);
        background-size: 100% auto;
        background-position: 0 0;
        background-repeat: no-repeat;
        transform: translateY(-50%);
      }
    }
  }
  .infor_center {
    width: 44.4vw;
    height: auto;

    .group_item {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      &.T {
        .participantItem {
          width: 100%;
        }
      }

      &.A {
        .participantItem {
          width: 100%;
        }
      }
      &.D {
        .participantItem {
          width: 50%;
        }
      }
      &.A,
      &.D {
        .participantItem {
          .participantLogo {
            position: relative;
            border-radius: 50%;
            width: 4.16vw;
            height: 4.16vw;
            overflow: hidden;
            background-size: 100% auto;
            background-repeat: no-repeat;
            background-position: left 35%;
            background-image: var(--mixtmt_default_playerLogo);
            &::after {
              position: absolute;
              content: '\20';
              bottom: 0;
              right: 0;
              z-index: 2;
              width: 100%;
              height: 100%;
              border-radius: 50%;
              border: 1px solid var(--mixtmt_greyColor5);
            }
            &.isLogo {
              background-image: none;
            }
            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 50%;
            }
          }
          .participantName {
            font-size: 1.11vw;
            width: 100%;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
        }
      }
      .vsArea {
        position: relative;
        width: 16.7vw;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        .vs {
          width: 4vw;
          font-size: 1.38vw;
          text-align: center;
          /* padding: 0 1.38vw; */
        }
        .leftScore,
        .rightScore {
          /* flex: 1; */
          width: calc(50% - 2vw);
          text-align: left;
          font-size: 2.778vw;
          font-weight: bold;
        }
        .leftScore {
          text-align: right;
        }
        .rightScore {
          text-align: left;
        }
        .stringScore {
          position: absolute;
          top: -1.388vw;
          z-index: 2;
          width: calc(50% - 2vw);
          font-size: 1.11vw;
          line-height: 1.388vw;
          font-weight: bold;
          &.home {
            left: 0;
            text-align: right;
          }
          &.away {
            right: 0;
            text-align: left;
          }
        }
        .absArea_currServe {
          pointer-events: none;
          bottom: -1.68vw;
          left: 0;
          z-index: 10;
          position: absolute;
          width: 100%;
          height: auto;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          padding: 0 5%;
          .currServeLeft,
          .currServeRight {
            width: 50%;
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            padding: 0 0.416vw 0 1.32vw;
            .currServe_icon {
              width: 1.68vw;
              height: 1.68vw;
              background-size: 100% 100%;
              background-repeat: no-repeat;
              background-image: var(--mixtmt_curServe_TEN_icon);
              transform: scale(0);
              transition: transform 0.2s linear;
              &.show {
                transform: scale(1);
              }
            }
            .currServe_scoreArea {
              width: calc(100% - 1.68vw);
              display: flex;
              display: -webkit-flex;
              justify-content: flex-start;
              align-items: center;
              color: var(--mixtmt_whiteColor);
              font-size: 1.11vw;
              .currServe_score {
                width: 2.778vw;
                text-align: center;
              }
            }
          }
          .currServeLeft {
            padding: 0 1.32vw 0 0.416vw;
            .currServe_scoreArea {
              justify-content: flex-end;
            }
          }
        }
      }
      .vsLeftArea,
      .vsRightArea {
        width: calc(50% - 8.35vw);
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
      }
      .participantItem {
        width: 50%;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        .participantLogo {
          width: 5.556vw;
          height: 3.958vw;
          padding: 0.347vw;
          background-color: var(--mixtmt_greyColor9);
          overflow: hidden;
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
            background-color: var(--mixtmt_greyColor0);
          }
        }
        .participantName {
          font-size: 1.25vw;
          line-height: 2.43vw;
          text-align: center;
        }
      }
    }
  }
}
.publishBtn {
  width: 2.2vw;
  height: 2.2vw;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  margin-left: 0.694vw;
  svg.publishBtn_icon {
    fill: var(--mixtmt_table_publicBtnColor);
  }
  &:hover {
    cursor: pointer;
    &:hover {
      svg.publishBtn_icon {
        fill: var(--mixtmt_subColor1_1);
      }
    }
  }
}
</style>
